import { useState } from 'react';

import type { FormValues } from './models';
import Step0A from './step0a';
import Step2A from './step2a';
import Step3A from './step3a';

export const SignupFormA = ({
  activeStep,
  setActiveStep,
}: {
  activeStep: number;
  setActiveStep: (step: number) => void;
}) => {
  const [formData, setFormData] = useState<FormValues>({
    name: 'abc',
    company: 'abc',
    email: 'abc',
  });

  if (activeStep === 2) {
    return <Step2A setActiveStep={setActiveStep} formData={formData} />;
  }

  if (activeStep === 3) {
    return <Step3A />;
  }

  return <Step0A setActiveStep={setActiveStep} setFormData={setFormData} />;
};
